const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_ADHOC_CALENDAR_REQUEST':
      return {
        ...state,
        status: 'loading',
        days: []
      }

    case 'FETCH_ADHOC_CALENDAR_DONE':
      return {
        ...state,
        status: 'ready',
        days: action.payload.days,
        receivedAt: action.payload.receivedAt,
        diagnostic_data: action.payload.diagnostic_data
      }

    case 'FETCH_ADHOC_CALENDAR_FAIL':
      return {
        ...state,
        status: 'error',
        days: []
      }

    case 'CLEAR_ADHOC_CALENDAR_DATA':
      return initialState

    default:
      return state
  }
}
